import Vue from "vue"

export const bus = new Vue()

window.bus = bus